RivalIQ.module('data', function (data) {
    'use strict';

    data.metricData = {
        companyData: {
            fetch: function (metric, attrs, callback) {
                attrs = metric.resolvedAttributes();

                const deferred = data.companyData.fetch(attrs);
                RivalIQ.utils.async.callbackToDeferred(callback, deferred);
            }
        }
    };
});
